import { render, staticRenderFns } from "./RiskScore.vue?vue&type=template&id=388c032e&"
import script from "./RiskScore.vue?vue&type=script&lang=js&"
export * from "./RiskScore.vue?vue&type=script&lang=js&"
import style0 from "./RiskScore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports